import React, { useEffect, useState } from 'react';
// Usa MUI v5 para mantener consistencia con el Dialog de EditarMtoPrev
import { Button, Tooltip, IconButton } from '@mui/material';
import { FaFilePdf, FaEyeSlash, FaArrowCircleLeft, FaPaperclip } from "react-icons/fa";

import { useHistory } from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEquipo, getCliente, getMtoPrev, getMtoPrevV2 } from '../../../redux/actions/dataactions';
import { PDFViewer } from '@react-pdf/renderer';
import './ReporteMtoPDF.css';
import ReporteMtoDocuPDF from './ReporteMtoDocuPDF';
import ReporteMtoDocuPDFV2 from './ReporteMtoDocuPDFV2';
// IMPORTA COMO DEFAULT (no con llaves)
import EditarMtoPrev from './EditarMtoPrev';

const ReporteMtoPDF = ({ getEquipo, getCliente, getMtoPrev, getMtoPrevV2, data, user, match }) => {
  const [verPDF, setVerPDF] = useState(false);
  const history = useHistory();

  const { equipo, cliente, mtopreventivo } = data;

  useEffect(() => {
    const { mtoid, equipoId, clienteId, version } = match.params;

    if (version === '2') {
      // mtoid es programacionid según tu comentario
      getMtoPrevV2(mtoid);
    } 
    else {
      getMtoPrev(mtoid);
    }

    getEquipo(equipoId);
    getCliente(clienteId);
  }, [getMtoPrev, getMtoPrevV2, getEquipo, getCliente, match.params]);

  const handleOpenPDF = () => setVerPDF((prev) => !prev);

  const goBack = () => history.goBack();

  const renderContent = () => {
    if (!cliente?.plantillaType) {
      return (
        <div className="mto-error-message">
          <p>Para ver las plantillas, primero debe configurar el tipo de plantilla en la lista de clientes</p>
        </div>
      );
    }

    if (equipo && cliente && verPDF) {
      if (mtopreventivo?.version === 2) {
        return (
          <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <ReporteMtoDocuPDFV2
              equipo={equipo}
              cliente={cliente}
              mtopreventivo={mtopreventivo}
            />
          </PDFViewer>
        );
      }

      return (
        <PDFViewer style={{ width: "100%", height: "90vh" }}>
          <ReporteMtoDocuPDF
            equipo={equipo}
            cliente={cliente}
            mtopreventivo={mtopreventivo}
          />
        </PDFViewer>
      );
    }

    return null;
  };

  return (
    <div className="mto-pdf-wrapper">
      <div className="mto-pdf-header">
        <div className="mto-pdf-back-btn">
          <MyButton tip="Volver" onClick={goBack}>
            <FaArrowCircleLeft className="mto-pdf-back-icon" />
          </MyButton>
        </div>

       {cliente?.plantillaType && (
         <Tooltip title={verPDF ? "Ocultar PDF" : "Ver PDF"}>
           <IconButton
            color="#03178C"
             onClick={handleOpenPDF}
             aria-label={verPDF ? "Ocultar PDF" : "Ver PDF"}
            size="large"
           >
            {verPDF ? <FaEyeSlash color='#03178C'/> : <FaFilePdf color='#03178C' />}
           </IconButton>
        </Tooltip>
       )}

        {mtopreventivo?.archivoPDF && (
          <Tooltip title="Abrir archivo adjunto">
            <IconButton
              onClick={() => window.open(mtopreventivo.archivoPDF, "_blank")}
              aria-label="Abrir archivo adjunto"
              size="large"
            >
              <FaPaperclip color='#03178C' />
            </IconButton>
          </Tooltip>
        )}

        {/* Arregla el condicional y protege ids opcionalmente */}
      {user?.credentials?.tipouser !== "Asistencial" && mtopreventivo?.version === 2 && mtopreventivo?.equipoid && (
    <EditarMtoPrev
      reportemto={mtopreventivo}
      equipoId={mtopreventivo.equipoid}
      clienteId={mtopreventivo.clienteid}
      cliente={cliente}
       disabled={verPDF}           // ⬅️ deshabilita cuando el PDF está abierto
          />
        )}
      </div>

      <div className="mto-pdf-content">
        {renderContent()}
      </div>
    </div>
  );
};

ReporteMtoPDF.propTypes = {
  getEquipo: PropTypes.func.isRequired,
  getMtoPrevV2: PropTypes.func.isRequired,
  getCliente: PropTypes.func.isRequired,
  getMtoPrev: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getEquipo, getCliente, getMtoPrev, getMtoPrevV2 })(ReporteMtoPDF);
